import React, { FC } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Button } from "../Button/Button";

interface ExpertDenialDialogProps {
  open: boolean;
  onClose: () => void;
  onReviewExperts: () => void;
  denialReason: string;
}

export const ExpertDenialDialog: FC<ExpertDenialDialogProps> = ({
  open,
  onClose,
  onReviewExperts,
  denialReason,
}) => {
  return (
    <Dialog open={open} fullWidth maxWidth="sm" onClose={onClose}>
      <DialogTitle>
        <div className="flex justify-between items-center">
          <Typography variant="h5" className="text-[20px]">
            Approval Denied
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon className="text-text-2" />
          </IconButton>
        </div>
      </DialogTitle>

      <DialogContent className="max-h-[60vh] overflow-y-auto">
        <hr className="border-t border-border-token mb-[24px]" />
        <Typography className="text-text-1 font-circular text-[16px] leading-[24px] pb-[8px]">
          Proposed experts were denied for the following reason(s):
        </Typography>
        <Typography 
          className="text-text-2 font-circular text-[16px] leading-[24px] pb-[24px] whitespace-pre-wrap break-words"
          style={{ wordWrap: 'break-word', overflowWrap: 'break-word' }}
        >
          {denialReason}
        </Typography>
        <hr className="border-t border-border-token" />
      </DialogContent>

      <DialogActions className="!px-6 !py-4">
        <Button
          variant="contained"
          onClick={onReviewExperts}
          className="h-[40px] flex items-center !py-0 !px-4 !min-w-fit"
        >
          Review Experts
        </Button>
      </DialogActions>
    </Dialog>
  );
};
